import React from "react";
import { StyleSheet, Modal, View, Text, Pressable } from "react-native";
import config from "../config/config";
import usePopUp from "../hooks/usePopUp";
import AppText from "./AppText";
import IconTouchable from "./IconTouchable";

function PopUpBox({ onPopUpPress }) {
    const { message, setMessage } = usePopUp();

    const resetModal = () => {
        setMessage(false);
        if (onPopUpPress) {
            onPopUpPress();
        }
    };

    return (
        <Modal animationType="fade" transparent={true} visible={message ? true : false}>
            <View style={styles.centeredView}>
                <View style={styles.modalView}>
                    <AppText style={{ textAlign: "center" }}>{message}</AppText>
                    <IconTouchable name="check" onPress={() => resetModal()} />
                </View>
            </View>
        </Modal>
    );
}

const styles = StyleSheet.create({
    centeredView: {
        flex: 1,
        justifyContent: "center",
    },
    modalView: {
        marginHorizontal: 20,
        backgroundColor: config.colors.white,
        borderRadius: 20,
        padding: 35,
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
    },
});

export default PopUpBox;
